import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./style.scss";
import { Translate } from "../../../Enums/Tranlate";
import AdminService from "../../../../services/AdminManagment/AdminService";
import { useNavigate } from "react-router-dom";

const HRMDashboard = () => {
	const [formData, setFormData] = useState([
		{ title: "total_employee", key: "totalEmployee", value: 0, icon: "user" },
		{ title: "on_leave_employee", key: "onLeaveEmployee", value: 0, icon: "home" },
		{ title: "total_project", key: "totalProject", value: 0, icon: "gear" },
		{ title: "compleat_project", key: "completedProject", value: 0, icon: "check-circle-o" },
		{ title: "total_client", key: "totalClient", value: 0, icon: "users" },
		{ title: "total_revenue", key: "totalRevenue", value: 0, icon: "arrow-up" },
		{ title: "total_jobs", key: "totalJobs", value: 0, icon: "suitcase" },
		{ title: "total_ticket", key: "totalTicket", value: 0, icon: "list" },
	]);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const navigate = useNavigate();

	useEffect(() => {
		setLoading(true);
		new AdminService()
			.getStats()
			.then((res) => {
				const stats = res?.data?.data ?? res?.data;
				if (stats) {
					setFormData((prev) =>
						prev.map((item) => ({
							...item,
							value: stats[item.key] ?? item.value,
						}))
					);
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	if (loading) {
		return (
			<Row>
				{formData?.map(() => {
					return (
						<Col className="col-md-4 col-sm-6">
							<Card style={{ height: "128.75px" }}>
								<Card.Body>
									<div class="skeleton-loader">
										<div class="loader-header"></div>
										<div class="loader-content"></div>
									</div>
								</Card.Body>
							</Card>
						</Col>
					);
				})}
			</Row>
		);
	}

	return (
		<div className="dashboard">
			<div className="row">
				{formData?.map((res, index) => {
					return (
						<div className="col-md-3 mb-3" key={index}>
							<div className="dashboard-card p-3">
								<i className={`fa fa-${res?.icon}`} />
								<div>
									<p className="title">{Translate[lang][res?.title]}</p>
									<p className="value">{res?.value}</p>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default HRMDashboard;
